import React, { createContext, useContext, useState, useRef, useEffect } from 'react';
 
const AuthContext = createContext();



export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {

  const [infoLoaded, setInfoLoaded] = useState(false);
    const [linkedinconnected, setlinkedinconnected] = useState(false);
    const [twitterconnected, settwitterconnected] = useState(false);
    const [twitterconnectedImages, settwitterconnectedImages] = useState(false);

    const [jwtToken, setJwt] = useState(null);
    const [picture, setpicture] = useState("https://schedpilot.com/img/av.png");
    const [name, setname] = useState("User");

    const [scheduled, setscheduled] = useState([]);
    const [published, setpublished] = useState([]);
    const [drafts, setdrafts] = useState([]);
    const [accounts, setAccounts] = useState([]);
    const [membership, setmembership] = useState({
      zeroMembership: "yes"
    });

 


    const addScheduledItem = (newItem) => {
      setscheduled([...scheduled, newItem]);
    };

    const addDraftItem = (newItem) => {
      setdrafts([...drafts, newItem]);
    };   

    
    const isValidMembership = () => {
  // If we haven't loaded info yet, don't claim it's invalid yet
  if (!infoLoaded) return true; 

  const m = Array.isArray(membership) ? membership[0] : membership;
  
  // If the placeholder is still there, it's not valid
  if (!m || m.zeroMembership === "yes" || !m.end_date_time) return false;

  // Standardize date comparison
  const endsAt = new Date(m.end_date_time.replace(' ', 'T') + 'Z');
  return endsAt.getTime() > Date.now();
};




const returnMembershipNotification = () => {
  if (!infoLoaded) return null;

  const m = Array.isArray(membership) ? membership[0] : membership;

  // Lifetime members never see membership warnings — their access never
  // expires, even if the row was somehow marked cancelled.
  const isLifetime = m?.plan?.type === "lifetime" || (
    m?.end_date_time
      ? new Date(m.end_date_time.replace(' ', 'T') + 'Z').getTime() > Date.now() + 10 * 365 * 24 * 3600 * 1000
      : false
  );
  if (isLifetime) return null;

  const expired = !isValidMembership();
  const isCancelled = m?.subscription_status === "cancelled";

  // CASE 1: Totally expired, invalid, or never had one
  if (m?.zeroMembership === "yes" || expired) {
    return (
      <div
        className="text-center mx-auto mb-4 p-4 p-md-5 rounded-4 shadow-sm"
        role="alert"
        style={{
          maxWidth: 640,
          background: 'linear-gradient(180deg, #fef3f3 0%, #ffffff 60%)',
          border: '1px solid #f3cccc',
        }}
      >
        <div
          className="d-inline-flex align-items-center justify-content-center mb-3"
          style={{ width: 64, height: 64, borderRadius: 18, background: '#fde4e4' }}
        >
          <svg width="30" height="30" viewBox="0 0 24 24" fill="none"
               stroke="#e23b3b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
          </svg>
        </div>

        <h4 className="fw-bold mb-2" style={{ color: '#0f172a' }}>
          You're one step away from publishing
        </h4>

        <p className="mb-4 mx-auto" style={{ maxWidth: 460, color: '#64748b', fontSize: '0.975rem', lineHeight: 1.6 }}>
          Pick a plan to unlock scheduling, AI-powered post writing, analytics, and team collaboration —
          everything you need to grow across all your platforms from one place.
        </p>

        <a
          href="/billing"
          className="btn btn-lg fw-bold px-4"
          style={{ background: '#2fba01', color: '#fff', borderRadius: 12, boxShadow: '0 6px 18px rgba(47,186,1,0.28)' }}
        >
          Choose your plan
        </a>

        <div className="mt-3" style={{ fontSize: '0.825rem', color: '#94a3b8' }}>
          Flexible plans for every team size · cancel anytime
        </div>
      </div>
    );
  }

  // CASE 2: Currently active BUT cancelled (Grace Period)
  // We show this in RED because you have no free tier and they will lose all access.
  if (isCancelled) {
    return (
      <div className="alert alert-danger mb-4 shadow-sm border-start border-4 border-danger" role="alert">
        <div className="d-flex align-items-center">
          <div className="flex-grow-1">
            <h5 className="fw-bold mb-1">Subscription Cancelled</h5>
            <p className="mb-0">
              Your access is set to <strong>expire on {new Date(m.end_date_time).toLocaleDateString()}</strong>. 
              After this date, your account will be deactivated and all scheduled posts will fail.
            </p>
          </div>
          <div className="ms-3">
            <a href="/billing" className="btn btn-outline-danger fw-bold">
              Restart Membership
            </a>
          </div>
        </div>
      </div>
    );
  }

  return null;
};


    const removeFromDrafts = (indexToRemove) => {
      setdrafts(prevData => {
        // Create a copy of the original array
        const newData = [...prevData];
        // Remove the item at the specified index
        newData.splice(indexToRemove, 1);
        // Set the state with the updated array
        return newData;
      });
    };



    const removeFromScheduled = (indexToRemove) => {
      setscheduled(prevData => {
        // Create a copy of the original array
        const newData = [...prevData];
        // Remove the item at the specified index
        newData.splice(indexToRemove, 1);
        // Set the state with the updated array
        return newData;
      });
    };


  const deleteAccount = async (accountId, acctype) => {
  const tokenFromLocalStorage = localStorage.getItem('jwtToken');

  if (!tokenFromLocalStorage) {
    console.error("No token found");
    return;
  }

  try {
    const response = await fetch('https://api.schedpilot.com/wp-json/api/v1/deleteSocialAccount', {
      method: 'POST',
      credentials: 'include', 
      headers: {
        'Content-Type': 'application/json',
 
      },
      body: JSON.stringify({ id: accountId, type: acctype })
    });

    const data = await response.json();

    if (data.code === 200) {
      //console.log("Account deleted successfully");
      // Optional: Remove the account from local state:
      getAccountsData();
      
    } else {
      console.error("Failed to delete account:", data.message);
    }
  } catch (error) {
    console.error("Error deleting account:", error);
  }
};



    const getAccountsData = async () =>{

      const tokenFromLocalStorage = localStorage.getItem('jwtToken')

      if(tokenFromLocalStorage != undefined)
      {

              fetch('https://api.schedpilot.com/wp-json/api/v1/getAccounts', {
          method: 'POST',
          credentials: 'include', 
          headers: {
            'Content-Type': 'application/json',
     
          }
        }).then(data => data.json()).then(MYJSON =>{



          //console.log(MYJSON)
         setAccounts(MYJSON.accounts)

        });

      }

    }


    const setJWTLocal = async () => {
        // Wait for the localStorage.getItem() to resolve before proceeding
        const tokenFromLocalStorage = await new Promise((resolve) => {
          resolve(localStorage.getItem('jwtToken'));
        });
  
        setJwt(tokenFromLocalStorage)
  
  
        fetch('https://api.schedpilot.com/wp-json/api/v1/getAllInformation', {
          method: 'POST',
          credentials: 'include',  
          headers: {
            'Content-Type': 'application/json' 
          }
        }).then(data => data.json()).then(MYJSON =>{

 
 
           if(MYJSON?.membership != null)
          {
            setmembership(MYJSON.membership);  
          }
 

          if(MYJSON?.data?.picture?.length > 2)
          {
                setpicture(MYJSON.data.picture);  
          }

          if(MYJSON?.scheduled?.length > 0)
            {
              setscheduled(MYJSON.scheduled)
            }

            if(MYJSON?.published?.length > 0)
              {
 
                setpublished(MYJSON?.published)
              }


              if(MYJSON?.drafts?.length > 0)
                {
                  setdrafts(MYJSON.drafts)
                }

                    if(MYJSON?.data?.name?.length > 1)
                    setname(MYJSON?.data?.name)                    

                    setInfoLoaded(true);
      });
  

      }

    useEffect(() => {

        setJWTLocal();
        getAccountsData();


    }, []);


    return (
        <AuthContext.Provider value={{ removeFromDrafts, removeFromScheduled,
          twitterconnectedImages, settwitterconnectedImages, membership,
           twitterconnected, settwitterconnected, deleteAccount, isValidMembership,
           linkedinconnected, jwtToken, setlinkedinconnected, picture, setpicture,  infoLoaded,
          drafts, setdrafts, name, setname, getAccountsData, accounts, setJWTLocal,
          published, setpublished, returnMembershipNotification,
            scheduled, addScheduledItem,
            addDraftItem
         }}>
          {children}
        </AuthContext.Provider>
      );

}